/* eslint-disable lines-between-class-members */
class TipoNoChatBotEnum {
    static Texto = {
      id: 1,
      nome: 'Texto',
    }
    static Fila = {
      id: 2,
      nome: 'Fila',
    }
    static Anterior = {
      id: 3,
      nome: 'Voltar ao menu anterior',
    }
    static Principal = {
      id: 4,
      nome: 'Voltar ao menu principal',
    }
    static Encerrar = {
      id: 5,
      nome: 'Encerrar atendimento',
    }
    static Arvore = {
      id: 6,
      nome: 'Árvore',
    }
    static Botao = {
      id: 7,
      nome: 'Botão',
    }
    static Lista = {
      id: 8,
      nome: 'Lista',
    }
    static Formulario = {
      id: 9,
      nome: 'Formulário',
    }
    static ChatGPT = {
      id: 10,
      nome: 'Chat GPT',
    }
    static NotaPesquisa = {
      id: 11,
      nome: 'Nota de pesquisa',
    }
    static Agendamento = {
      id: 12,
      nome: 'Agendamento',
    }
    static API = {
      id: 13,
      nome: 'API',
    }
}

export default TipoNoChatBotEnum
